export const RECENT_FILTERS_LIMIT = 17;

export const FIXED_FILTERS = [
  {
    name: 'All Traffic',
    rule: [],
    rule_text: '(All Traffic)',
  },
  {
    name: 'Live Traffic',
    rule: [[{
      field: 'LIVE_VIDEO', value: 'T', display: 'Live Traffic', key: null, op: 'eq',
    }]],
    rule_text: '(Content Category EQUALS Live)',
  },
  {
    name: 'VOD Traffic',
    rule: [[{
      field: 'LIVE_VIDEO', value: 'F', display: 'VOD Traffic', key: null, op: 'eq',
    }]],
    rule_text: '(Content Category EQUALS VoD)',
  },
];

export const FIXED_APP_FILTERS = [
  {
    name: 'All Traffic',
    rule: [],
    rule_text: '(All Traffic)',
  }
];

export const categoryMap = new Map();
categoryMap.set('OBJECT_NAME', { category: 'CONTENT', subcategory: 'Asset' });
categoryMap.set('LIVE_VIDEO', { category: 'CONTENT', subcategory: 'Asset' });
categoryMap.set('GEO_CONTINENT', { category: 'GEO', subcategory: 'Continent' });
categoryMap.set('GEO_COUNTRY', { category: 'GEO', subcategory: 'Country' });
categoryMap.set('GEO_STATE', { category: 'GEO', subcategory: 'State' });
categoryMap.set('GEO_CITY', { category: 'GEO', subcategory: 'City' });
categoryMap.set('GEO_DMA', { category: 'GEO', subcategory: 'DMA' });
categoryMap.set('GEO_POSTAL_CODE', { category: 'GEO', subcategory: 'Postal Code' });
categoryMap.set('GEO_ASN', { category: 'NETWORK', subcategory: 'ASN' });
categoryMap.set('CDN', { category: 'NETWORK', subcategory: 'CDN' });
categoryMap.set('GEO_ISP', { category: 'NETWORK', subcategory: 'ISP' });
categoryMap.set('RESOURCE_ID', { category: 'NETWORK', subcategory: 'Resource' });
categoryMap.set('BROWSER', { category: 'DEVICE', subcategory: 'Browser' });
categoryMap.set('BROWSER_VERSION', { category: 'DEVICE', subcategory: 'Browser' });
categoryMap.set('DEVICE_MODEL', { category: 'DEVICE', subcategory: 'Type' });
categoryMap.set('DEVICE_TYPE', { category: 'DEVICE', subcategory: 'Type' });
categoryMap.set('DEVICE_VERSION', { category: 'DEVICE', subcategory: 'Type' });
categoryMap.set('OS', { category: 'DEVICE', subcategory: 'Operating System' });
categoryMap.set('OS_VERSION', { category: 'DEVICE', subcategory: 'Operating System' });
categoryMap.set('CLIENT_ID', { category: 'DEVICE', subcategory: 'Player' });
categoryMap.set('PLAYER_NAME', { category: 'DEVICE', subcategory: 'Player' });
categoryMap.set('PLAYER_MAJOR_VERSION', { category: 'DEVICE', subcategory: 'Player' });
categoryMap.set('PLAYER_TYPE', { category: 'DEVICE', subcategory: 'Platform' });
categoryMap.set('PLATFORM_VERSION', { category: 'DEVICE', subcategory: 'Platform' });
categoryMap.set('FRAMEWORK', { category: 'DEVICE', subcategory: 'Framework' });
categoryMap.set('FRAMEWORK_VERSION', { category: 'DEVICE', subcategory: 'Framework' });

export const EXISTING_FILTER_PANEL_KEY = '1';
export const SAVE_FILTER_PANEL_KEY = '2';
export const MANAGE_FILTERS = 'Manage Filters';
export const DEFAULT_FILTERS = 'Default';
export const RECENT_FILTERS = 'Recent';
